<template>
  <div class="pie-chart">
    <x-loading :visible="loading">
      <v-chart
        ref="chart"
        :options="options"
        :theme="theme"
        class="inner-chart"
      ></v-chart>
    </x-loading>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import theme from './dap-chart-theme.json'
import apis from '@/api'

export default {
  components: {
    'v-chart': ECharts
  },
  props: {
    chartConfig: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      data: [],
      theme: theme,
      loading: false,
      queryParams: {}
    }
  },
  computed: {
    pieData: function() {
      let list = []
      this.data.forEach(ele => {
        list.push({
          name: ele.xaxisField,
          value: parseFloat(ele.yaxisValues[0].value)
        })
      })
      return list
    },
    options: function () {
      return {
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{b} {c} ({d}%)',
          backgroundColor: 'rgba(255,255,255,0)',
          transitionDuration: 0
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          bottom: 10,
          itemWidth: 12.5,
          textStyle: {
            color: '#000000',
            fontSize: 12
          },
          type: 'scroll',
          data: this.pieData.map(item => item.name)
        },
        series: [
          {
            type: 'pie',
            hoverOffset: 5,
            center: ['50%', '40%'],
            radius: '60%',
            label: {
              formatter: '{b} {c} ({d}%)'
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: this.pieData
          }]
      }
    }
  },
  created() {
    this.queryParams = this.$route.query
    this.queryData()
  },
  methods: {
    refresh() {
      this.queryData()
    },
    queryData() {
      const request = {
        ...apis.FORM.GET_PIE_DATA,
        params: {
          reportFormId: this.queryParams.formId,
          chartUuid: this.chartConfig.uuid
        }
      }
      this.loading = true
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.data = resp.data.chartDatas || []
            this.loading = false
            this.resizeTheChart()
          },
          () => {
            this.loading = false
          }
        )
        .asyncErrorCatch(
          () => {
            this.loading = false
          }
        )
    },
    resizeTheChart() {
      setTimeout(() => {
        this.$refs.chart && this.$refs.chart.resize()
      })
    }
  }
}
</script>

<style lang="scss">
.pie-chart {
  height: 14.7rem;
  .x-loading, .x-loading > img {
    margin: auto;
    height: 100%;
  }
  .x-loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .inner-chart {
    width: 100%;
    height: 100%;
  }
}
</style>
